package com.devi3east.bashbuddy.auth.ui.components

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.IntSize
import androidx.compose.ui.unit.dp
import com.devi3east.bashbuddy.account.organization.domain.models.Organization

@Composable
fun OrganizationPicker(
    organizations: List<Organization>,
    selectedOrganization: Organization?,
    label: String = "Organization (optional)",
    onSelected: (Organization) -> Unit,
    modifier: Modifier = Modifier
) {
    val cardShape = RoundedCornerShape(12.dp)
    var expanded by remember { mutableStateOf(false) }

    val displayText = selectedOrganization?.organizationName ?: ""

    var fieldSize by remember { mutableStateOf(IntSize.Zero) }
    val density = LocalDensity.current

    Box(
        modifier = modifier
            .fillMaxWidth()
            .clip(cardShape)
            .clickable { expanded = true }
            .onGloballyPositioned { coordinates ->
                fieldSize = coordinates.size
            }
    ) {
        OutlinedTextField(
            value = displayText,
            onValueChange = {},
            label = {
                Text(
                    text = label,
                    style = LocalTextStyle.current.copy(
                        color = if (displayText.isNotBlank())
                            MaterialTheme.colorScheme.onSurface
                        else
                            MaterialTheme.colorScheme.onSurfaceVariant
                    )
                )
            },
            readOnly = true,
            enabled = false,
            singleLine = true,
            modifier = modifier.fillMaxWidth(),
            shape = cardShape,
            colors = OutlinedTextFieldDefaults.colors(
                focusedTextColor = MaterialTheme.colorScheme.onSurface,
                unfocusedTextColor = MaterialTheme.colorScheme.onSurfaceVariant,
                disabledTextColor = MaterialTheme.colorScheme.onSurface,
                focusedBorderColor = MaterialTheme.colorScheme.primary,
                unfocusedBorderColor = MaterialTheme.colorScheme.outline,
                disabledBorderColor = MaterialTheme.colorScheme.outline,
                cursorColor = MaterialTheme.colorScheme.primary
            )
        )

        DropdownMenu(
            expanded = expanded,
            onDismissRequest = { expanded = false },
            modifier = modifier
                .width(with(density) { fieldSize.width.toDp() })
                .clip(cardShape)
        ) {
            organizations.forEach { org ->
                DropdownMenuItem(
                    text = {
                        Text(
                            text = org.organizationName ?: "Unnamed",
                            style = MaterialTheme.typography.bodyLarge,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis,
                            textAlign = TextAlign.Center
                        )
                    },
                    onClick = {
                        onSelected(org)
                        expanded = false
                    }
                )
            }
        }
    }
}